import { render, staticRenderFns } from "./ComEmail.vue?vue&type=template&id=1df6d6ce&scoped=true&"
import script from "./ComEmail.vue?vue&type=script&lang=js&"
export * from "./ComEmail.vue?vue&type=script&lang=js&"
import style0 from "./ComEmail.vue?vue&type=style&index=0&id=1df6d6ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df6d6ce",
  null
  
)

export default component.exports